export const anxiousGenerationContent = (
  <>
    <div className="prose dark:prose-invert max-w-none text-text-muted-light dark:text-text-muted-dark">
      <h2>The Challenge</h2>
      <p>
        Jonathan and his team didn&rsquo;t just want to create a book. They
        wanted to create a movement. They wanted a site that could educate you
        about the book, but more importantly compelled visitors to want to
        become a part of the movement itself.
        <br />
        We also had a pretty tight deadline. They had an opportunity for a piece
        in The Atlantic, and needed an initial version of a site up to have a
        place to send people and ideally capture newsletter signups.
      </p>

      <h2>Working Iteratively</h2>
      <p>
        We started with something small, focusing exclusively on the homepage.
        The goal was to communicate the key ideas of the book, cast the vision
        for the movement, and capture signups. We got it designed and built in
        just a few weeks, in time for the Atlantic piece. Which was good,
        because thousands of people signed up right away.
      </p>
      <p>
        We&rsquo;re working together to build out the site over time, which
        allows the team to make decisions as they learn. Rather than making
        arbitrary decisions up front that will likely be wrong, we&rsquo;re
        making them as we go. It&rsquo;s a much tighter collaboration than a
        typical agency/client relationship.
      </p>

      <h2>The Importance of Storytelling</h2>
      <p>
        Movements aren&rsquo;t about features or benefits. They&rsquo;re about
        stories. You have to capture the imagination of your visitors. You have
        to cast a vision of what a better future looks like, and why being part
        of the movement is important. You&rsquo;re creating missionaries, not
        users.
      </p>
      <p>
        We worked closely with the author and his team to tell the story as
        clearly and persuasively as possible.
      </p>

      <video controls preload="metadata" poster="/assets/work/rich-poster.png">
        <source src="/assets/work/tag-township-clip.mp4" type="video/mp4" />
        Your browser does not support the video tag.
        <track
          kind="captions"
          srcLang="en"
          src="/assets/work/tag-township-clip.vtt"
          label="English captions"
          default
        />
      </video>

      <p>
        Excerpt from{" "}
        <a
          href="https://www.youtube.com/watch?v=Nq6xnHQ8HeE"
          target="_blank"
          rel="noopener noreferrer"
        >
          The TRUTH About Social Media & Your Children, Jonathan Haidt on the
          Rich Roll Podcast
        </a>
      </p>

      <h2>Avoiding Design Theater</h2>
      <p>
        The best client-firm relationships are built on shared trust. And one
        manifestation of that is you don&rsquo;t need to create deliverables for
        deliverables sake.
      </p>
      <p>
        Because of their emphasis on speed and organically building out the
        site, we&rsquo;ve been way less picky in Figma. We do a couple versions,
        get their feedback, and get to code quickly. We don&rsquo;t like editing
        artifacts that will ultimately go away if we don&rsquo;t have to.
      </p>
      <p>
        We don&rsquo;t worry about creating prototypes that anticipate every
        scenario. We trust we&rsquo;ll address those things as they come. But
        this approach requires trust on both sides.
      </p>

      <h2>Bespoke Solutions Allow for Creative Solutions</h2>
      <p>
        One tool we created was a sample petition. Users would fill out some
        fields, and it would generate a custom printable PDF file for them.
      </p>
      <p>
        Another example was their world map of aligned organizations. We created
        a Google Spreadsheet and a series of automations, generating a JSON file
        that loads the organizations on an interactive map. This allows them to
        add organizations over time, without having to build out a complex CMS
        to handle it.
      </p>
      <p>
        Trying to track down WordPress plugins and wrangling them to do what you
        need is frustrating and ineffective. It&rsquo;s faster to code it, and
        you get exactly what you want.
      </p>
      <p>
        (For those who care, this site was built in Next.js, using Contentful as
        the headless CMS, hosted on Vercel. It&rsquo;s integrated with HubSpot
        to handle their newsletter and forms.)
      </p>
      <p>
        Doing that requires an understanding. Either you will be handling the
        responsibilities for maintenance as the client, or you&rsquo;re signing
        up for a longer-term relationship with your firm. Jonathan and his team
        understood this. They want this to be a living breathing site that
        evolves as they learn.
      </p>
    </div>
  </>
);
